module.exports = __webpack_public_path__ + "img/lowD.e2e8a86e.png";